import { render, staticRenderFns } from "./ImagePair.vue?vue&type=template&id=578fe6c7&scoped=true"
import script from "./ImagePair.vue?vue&type=script&lang=ts"
export * from "./ImagePair.vue?vue&type=script&lang=ts"
import style0 from "./ImagePair.vue?vue&type=style&index=0&id=578fe6c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fe6c7",
  null
  
)

export default component.exports